import { isAxiosError, default as axios } from 'axios';
import { isInitialized, captureException } from '@sentry/vue';

axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (isInitialized()) {
      if (isAxiosError(error)) {
        if (error.status === 403) {
          captureException(error, { mechanism: { handled: true } });
        }
      }
    }

    return Promise.reject(error);
  },
);
